import { AnalyticsPlatformService } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/platform/platform.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaAnalyticsPlatformV1Service = bindHTTP(AnalyticsPlatformService);
export const serviceName = 'analytics-platform-v1' as const;
